exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.arouse-wrapper[data-v-5957c888] {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 2;\n}\n.arouse-wrapper img[data-v-5957c888] {\n  width: 100%;\n  height: 100%;\n}", "", {"version":3,"sources":["/var/corecdci/src/components/arouse/<input css 8>"],"names":[],"mappings":";AAAA;EACE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,QAAQ;EACR,SAAS;EACT,WAAW;CACZ;AAED;EACE,YAAY;EACZ,aAAa;CACd","file":"index.vue","sourcesContent":[".arouse-wrapper {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 2;\n}\n\n.arouse-wrapper img {\n  width: 100%;\n  height: 100%;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5957c888","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/arouse/index.vue
// module id = ZnwE
// module chunks = 6